import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetUserSso as GetUserSsoQuery,
    GetUserSsoVariables as GetUserSsoVariables,
    GetUserSso_user as User,
} from 'nutshell-graphql-types';

import GET_USER_SSO from '../queries/get-user-sso.graphql';

export const useGetUserSso = (
    userId: string
): {
    user: User | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetUserSsoQuery, GetUserSsoVariables>(
        GET_USER_SSO,
        {
            variables: {
                userId,
            },
        }
    );

    const user = data ? data.user : null;

    return {
        user,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
